import React from "react";
import { Button, Card, Divider, Stack, Typography } from "@mui/material";
import "../../assets/styles.css";
import viewIcon from "../../assets/images/icon-view.svg";
import {Right} from "@icon-park/react"
interface GeneralCardProps {
  data: any;
  handleClick: (a: any) => void;
  cardContainerClass?: any
  cardContainerStyle?: any
}

const GeneralCard: React.FC<GeneralCardProps> = ({ data, handleClick, cardContainerClass, cardContainerStyle}) => {
  const Icon = data.icon;
  return (
    <Card className={`abc generalCard ${cardContainerClass}`} style={cardContainerStyle}>
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        className="def"
      >
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="8px"
          className="ghi"
        >
          {/* <img src={data.image} alt="icon access" /> */}
            <Icon stroke={1.4} color="#ffffff"/>
          <Typography className={`cardTitle`}>{data?.cardTitle}</Typography>
        </Stack>
      </Stack>
      <Divider className={`cardDivider`}></Divider>
      <Typography
        className={`cardContent lineClampEllipsis`}
      >
        {data?.cardContent}
      </Typography>
      <Button 
        className={`cardButton`} 
        onClick={() => handleClick(data?.name)}
        sx={{
            display: "flex",
            alignItems: "center",
            gap: "1px",
            minWidth: "unset",
            padding: 0,
          }}
        >
        View
        {/* <img src={viewIcon} alt="view icon" /> */}
      <Right 
          theme="outline" 
          size="18" 
          fill="#17B2EB" 
          strokeWidth={3}  
          style={{
          display: "flex",
          alignSelf: "center",
          marginTop: "1px",
        }}
    />
      </Button>
    </Card>
  );
};

export default GeneralCard;
